module.exports = __webpack_public_path__ + "images/stepDarkBg.ba41a5e5.svg";